#import "../../../../graphql/fragments/sales-automation-stageset.graphql"

mutation DeleteClosedLeadFollowupAutomation($input: FollowupLeadAutomationDeleteInput!) {
    followupLeadAutomationDelete(input: $input) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
